module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col span-1-of-2"
  }, [_c('ul', {
    staticClass: "footer-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About us")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Press")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col span-1-of-2"
  }, [_c('ul', {
    staticClass: "social-links"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "ion-social-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "ion-social-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "ion-social-googleplus"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "ion-social-instagram"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', [_vm._v("\n            Copyright © 2015 by ihd. All rights reserved.\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9a594d44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Footer.vue
// module id = 108
// module chunks = 0